import { useEffect, useState } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import {
    Box,
    Button,
    Grid,
    Typography,
    TextField,
    Select,
    MenuItem,
    Autocomplete,
    CircularProgress,
    Checkbox,
    FormControl
} from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';
import { gridSpacing } from 'app/constant';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { errorAlert } from 'ui-component/Toasts';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import useFetchData from 'hooks/useFetchData';

const FollowUpReport = () => {
    const token = useSelector(selectCurrentToken);

    const [reports, setReports] = useState([]);
    const [filterDate, setFilterDate] = useState(dayjs());
    const [filterTypeID, setFiterTypeID] = useState();

    const [isLoading, setLoading] = useState(false);

    const fetchReports = async () => {
        let reportsURL = `/Report/FollowUp?`;

        if (filterTypeID !== '') {
            reportsURL += `followUpFilterTypeID=${filterTypeID}`;
        }
        if (filterDate !== '') {
            reportsURL += `&dateLabel=${filterDate.format('YYYY-MM-DD')}`;
        }

        setLoading(true);
        try {
            const res = await axiosInstance.get(reportsURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setReports(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const { data: filterTypes } = useFetchData('/Report/FollowUp/FilterType/All');

    return (
        <Grid container item xs={12} padding="20px">
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Date :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterDate}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setFilterDate(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>

                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Filter Type :
                        </Typography>
                        <FormControl fullWidth>
                            <Select value={filterTypeID} onChange={(e) => setFiterTypeID(e.target.value)} sx={{ minWidth: '200px' }}>
                                {filterTypes.map((f) => {
                                    return (
                                        <MenuItem key={f.id} value={f.id}>
                                            {f.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={12} lg={12}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '30px'
                        }}
                        onClick={() => fetchReports()}
                        disabled={isLoading}
                    >
                        Filter
                    </Button>
                </Grid>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable reports={reports} filterDate={filterDate} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default FollowUpReport;
